import { render } from "./ExternalLayout.vue?vue&type=template&id=6970d46c"
import script from "./ExternalLayout.vue?vue&type=script&lang=js"
export * from "./ExternalLayout.vue?vue&type=script&lang=js"

import "./ExternalLayout.vue?vue&type=style&index=0&id=6970d46c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__